import { createTw } from "react-pdf-tailwind";

const tw = createTw({
    theme: {}
})

export default tw;